/**
 * 从 get_kfz_info 开发者信息解析账户安全开关。
 * @param {Object} developerInfo
 * @returns {{ independentPwdOn: boolean, smsOn: boolean }}
 */
export function parseAccountSecurityFromDeveloperInfo(developerInfo = {}) {
  return {
    /** sec_pw：0 无二级密码，1 有 */
    independentPwdOn: Number(developerInfo.sec_pw) === 1,
    /** phone_auth：0 关闭手机验证，1 开启 */
    smsOn: Number(developerInfo.phone_auth) === 1,
  };
}
